import { getEnvIMbaseURL } from '@/utils/env'
import { postAction } from './request'

const host = getEnvIMbaseURL()

/**
 * 请求会话历史消息
 * @param {*} params
 * @returns
 */
export async function fetchMessageList(params = {}) {
  return postAction(`${host}/voghion-im/conversation/details`, params, {
    retry: 3
  })
}

/**
 * 请求历史会话列表
 * @param {*} params
 * @returns
 */
export async function fetchChatList(params = {}) {
  return postAction(`${host}/voghion-im/conversation/history`, params, {
    retry: 3
  })
}

export async function fetchEndpointConfig(params = {}) {
  return postAction(`${host}/voghion-im/endpoint/configs`, {})
}

/**
 * 全部清除已读消息
 */
export async function clearAllChat(params) {
  return postAction(`${host}/cms/message-box/allMsg/clear`, params)
}

/**
 * 获取评论
 * @param {*} params
 * @returns
 */
export async function fetchEvaluationConfig(params) {
  return postAction(`${host}/cms/customer-service/evaluationConfig`, params)
}

export async function submitReview(params) {
  return postAction(`${host}/cms/customer-service/saveEvaluation`, params)
}

export async function fetchDiversionIM(params) {
  return postAction(`${host}/cms/customer-service/diversionIm`, params, {
    retry: 3
  })
}

export async function fetchDefaultChat(params) {
  return postAction(`${host}/cms/customer-service/configsV2`, params)
}

/**
 *  获取类目会话
 * @param {*} params
 * @returns
 */
export async function fetchCategoryExperts(params = {}) {
  return postAction(`${host}/cms/customer-service/categoryExperts`, params)
}